const STORAGE_KEY = 'omt:wishlist';

function readWishlist() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch (error) {
    return [];
  }
}

function writeWishlist(ids) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

function syncButton(button) {
  const ids = readWishlist();
  const isSaved = ids.includes(button.dataset.productId);
  button.setAttribute('aria-pressed', String(isSaved));
  const label = isSaved ? button.dataset.labelRemove : button.dataset.labelAdd;
  if (label) {
    button.setAttribute('aria-label', label);
    const textTarget = button.querySelector('[data-wl-label]');
    if (textTarget) textTarget.textContent = label;
  }
}

function toggle(button) {
  const ids = readWishlist();
  const id = button.dataset.productId;
  const next = ids.includes(id) ? ids.filter((existing) => existing !== id) : ids.concat(id);
  writeWishlist(next);
  document.querySelectorAll(`.js-wishlist-toggle[data-product-id="${id}"]`).forEach(syncButton);
}

function bindOne(button) {
  syncButton(button);
  button.addEventListener('click', () => toggle(button));
}

function bindAll(root) {
  if (root.nodeType !== 1) return;
  if (root.matches?.('.js-wishlist-toggle')) bindOne(root);
  root.querySelectorAll?.('.js-wishlist-toggle').forEach(bindOne);
}

bindAll(document.documentElement);

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => mutation.addedNodes.forEach(bindAll));
});
observer.observe(document.body, { childList: true, subtree: true });
